import React from 'react'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import { withStyles } from 'material-ui/styles'

import styles from '../styles'
import withRole from '../../hoc/role'

import {
  ROLES_CLIENT_ADMIN,
  ROLES_CLIENT_MANAGER
} from '../../../common/constants'

const AddButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_add")} disableTriggerFocus={true}>
      <Button aria-label="Add Customer" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>add</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])

const EditButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_edit")} disableTriggerFocus={true}>
      <Button aria-label="Edit" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>edit</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])

const DeleteButton = withRole((props) => {
  return (
    <Tooltip title={props.translate("tooltip_delete")} disableTriggerFocus={true}>
      <Button aria-label="Delete" className={props.classes.button} color="primary" fab mini onClick={props.onClick}>
        <Icon>delete</Icon>
      </Button>
    </Tooltip>
  )
}, [...ROLES_CLIENT_ADMIN, ...ROLES_CLIENT_MANAGER])

class Toolbar extends React.Component {

  render() {

    const {
      classes,
      translate,
      toggle,
      add,
      edit,
      remove,
      selectedRecords,
      toggleFilters
    } = this.props

    return (
      <div>
        <AddButton classes={classes} translate={translate} onClick={() => add()} />
        {(selectedRecords.length > 0) && (<EditButton translate={translate} classes={classes} onClick={() => edit()} />)}
        {(selectedRecords.length > 0) && (<DeleteButton translate={translate} classes={classes} onClick={() => remove()} />)}

        <Tooltip title={translate("tooltip_filter")} disableTriggerFocus={true}>
          <Button aria-label="Filter" className={classes.button} color="primary" fab mini onClick={() => toggleFilters()}>
            <Icon>filter_list</Icon>
          </Button>
        </Tooltip>

        <Tooltip title={translate("tooltip_view_columns")}  disableTriggerFocus={true}>
          <Button aria-label="View Columns" className={classes.button} color="primary" fab mini onClick={() => toggle()}>
            <Icon>view_column</Icon>
          </Button>
        </Tooltip>
      </div >
    )
  }
}


export default withStyles(styles)(Toolbar)
